import { ElementRef, ViewChild, Component, input, output, computed, ChangeDetectionStrategy } from '@angular/core'

@Component({
  selector: 'btn',
  templateUrl: 'btn.component.html',
  styleUrls: ['btn.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BtnComponent {
  @ViewChild('btn') btn: ElementRef

  label = input<string>('')
  btnType = input<string>('button')
  btnDisabled = input<boolean>(false)
  classes = input<string[]>([])
  icon = input<string>('')
  iconPosition = input<string>('')
  trackCategory = input<string>('event-click-button')
  trackAction = input<string>('')
  trackValue = input<string>('')
  isBackButton = input<boolean>(false)
  isLoading = input<boolean>(false)
  spinnerClassesString = input<string>('')
  dataCyAttribute = input<string>('')

  onEvent = output<any>()

  classesString = computed(() => {
    let classesAdditional = ''
    if (this.classes() && this.classes().length > 0) {
      this.classes().forEach(cls => {
        classesAdditional += ' ' + cls
      })
    }
    return (
      classesAdditional +
      (classesAdditional.length > 0 ? '' : ' btn-third') +
      (this.isBackButton() ? ' back-button' : '')
    )
  })

  iconClassesString = computed(() => {
    let iconClasses = ''
    if (this.icon() && this.icon().length > 0) {
      iconClasses += this.icon().split('-')[0]
      iconClasses +=
        ' ' +
        this.icon().replace('far-', 'fa-').replace('fas-', 'fa-') +
        (this.label && this.label.length > 0 ? ' me-2' : '')
      iconClasses += ' ' + this.icon()
    }
    return iconClasses
  })

  getTrackAction = computed(() => {
    this.trackAction() ? this.trackAction() : this.label()
  })

  triggerEvent(): void {
    this.onEvent.emit(true)
  }
}
